import { render, staticRenderFns } from "./PaymentsReceivedNew.vue?vue&type=template&id=61b91090&scoped=true"
import script from "./PaymentsReceivedNew.vue?vue&type=script&lang=js"
export * from "./PaymentsReceivedNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b91090",
  null
  
)

export default component.exports